import { DT_SCREEN } from '@/core/constants/dynatraceScreens';
import { useCatalogDynatraceView } from '@/core/hooks/useCatalogDynatraceView';
import { RegistrationSuccessScreen } from '@/modules/onboarding/registration';
import React from 'react';

function PasswordSentRoute() {
    useCatalogDynatraceView(DT_SCREEN.PASSWORD_SENT, 'password_sent_viewed', true);
    return <RegistrationSuccessScreen />;
}

export default PasswordSentRoute;